
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService, CandidateSessionService } from
  '../services/auth/auth.service';

export const adminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (!auth.hasRole('Operations')) {
    return router.createUrlTree(['/login']);
  }

  return true;
};

export const mensaAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (!auth.isLoggedIn()) {
    return router.createUrlTree(['/login']);
  }

  if (!auth.hasRole('Mensa Admin')) {
    return router.createUrlTree(['/login']);
  }

  return true;
};

export const candidateGuard: CanActivateFn = () => {
  const session = inject(CandidateSessionService);
  const router = inject(Router);

  return session.isAuthenticated()
    ? true
    : router.createUrlTree(['/candidate/entry']);
};
